import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/air-api-constant";

@Injectable({
  providedIn: 'root'
})
export class PortalProfileService {

  constructor(protected http: HttpClient) { }
  public getKeyReferenceNumber() {
    return new Promise((resolve: any, reject: any) => {
      let url = settings.UserEndPoint.PortalProfile.GET_KEY_REFERENCE_NUMBER;
      this.http.get<any>(url).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }
  public setKeyReferenceNumber(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SET_KEY_REFERENCE_NUMBER;
    return this.http.post(url, body);

  }
  public getSavedFilters() {
    let url = settings.UserEndPoint.PortalProfile.GET_SAVED_FILTERS;
    return this.http.get<any>(url)
  }

  public setSavedFilters(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SET_SAVED_FILTERS;
    return this.http.post(url, body);
  }
  public deleteSavedFilters(body: any) {
    let url = settings.UserEndPoint.PortalProfile.DELETE_FILTER;
    return this.http.post(url, body);
  }
  public getUserSavedColumnSequence(body: any) {
    let url = settings.UserEndPoint.UserPortal.GET_USER_SAVED_COLUMN_SEQUENCE;
    return this.http.post(url,body)
  }

  public setUserSavedColumnSequence(type: any, columnSequence: any) {
    let body = {
      "pageType": type,
      "columnSeqJson": columnSequence,
      "userId": "",
    }
    let url = settings.UserEndPoint.UserPortal.SET_USER_SAVED_COLUMN_SEQUENCE;
    return this.http.post(url, body)
  }
}

